import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { IconButton, Stack, Tooltip } from '@collaborate-health/uikit'
import { VisibilityOutlined } from '@mui/icons-material'
import { UserQualificationStatusChip } from '@tabeeb/modules/qualifications/components'
import CheckInQualificationPopover from '@tabeeb/modules/checkIns/components/CheckInsList/CheckInQualificationPopover'
import { Grid } from '@mui/material'
import { CheckInQualificationProps } from './CheckInQualification.types'
import { MultiLineCaption } from './CheckInQualification.styles'

const CheckInQualification: React.FC<CheckInQualificationProps> = ({
  qualificationVersion,
  user,
  renderQualificationDetails = true,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const textRef = useRef<HTMLSpanElement>(null)
  const handleOpenQualification = useCallback((e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget), [])
  const handleCloseQualification = useCallback(() => setAnchorEl(null), [])

  const popoverOpen = useMemo(() => Boolean(anchorEl), [anchorEl])

  const [isTextClipped, setIsTextClipped] = useState(false)

  useEffect(() => {
    if (textRef.current) {
      setIsTextClipped(textRef.current.scrollWidth > textRef.current.clientWidth)
    }
  }, [])

  if (!renderQualificationDetails) {
    return (
      <Stack direction='row' spacing={1} alignItems='center' minWidth={0} width='100%'>
        <MultiLineCaption flex={1} minWidth={0}>
          {qualificationVersion.Name}
        </MultiLineCaption>
        <UserQualificationStatusChip status={qualificationVersion.Status} variant='outlined' />
      </Stack>
    )
  }

  return (
    <Grid container spacing={1} direction='row' alignItems='center' width='100%'>
      <Grid item xs={2}>
        <IconButton size='small' onClick={handleOpenQualification}>
          <VisibilityOutlined color='primary' />
        </IconButton>
      </Grid>

      <Grid item xs={6} minWidth={0}>
        <Tooltip text={isTextClipped ? qualificationVersion.Name : ''}>
          <MultiLineCaption ref={textRef} display='block'>
            {qualificationVersion.Name}
          </MultiLineCaption>
        </Tooltip>
      </Grid>
      <Grid item xs={4}>
        <UserQualificationStatusChip status={qualificationVersion.Status} variant='outlined' maxWidth={90} />
      </Grid>
      <CheckInQualificationPopover
        anchorEl={anchorEl}
        onClose={handleCloseQualification}
        open={popoverOpen}
        qualificationVersion={qualificationVersion}
        user={user}
      />
    </Grid>
  )
}

export default CheckInQualification

